/**
 * Фильтры
 */
class Filter {
    constructor(el) {
        this.container = el;
        this.inputs = this.container.querySelectorAll('select, input');

        this.bindChange();
    }

    bindChange() {
        this.inputs.forEach(input => {
            input.addEventListener('change', () => {
                /**
                 * Раздисейбливаем кнопку сабмита
                 * при изменении параметров
                 */
                this.container
                    .querySelectorAll('[type="submit"]')
                    .forEach(btn => btn.disabled = false);
            });
        });
    }
}

document.querySelectorAll('.js-filter').forEach(el => new Filter(el));



// WEBPACK FOOTER //
// ./_src/js/Filter.js